import React from 'react';
import { FlatList, View } from 'react-native'

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import api from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { useRoute } from '@react-navigation/native';

import PaymentRequestRow from './components/PaymentRequestRow'


export default function PaymentRequestScreen({ }) {
  const route = useRoute();
  const { filterPending = false } = route.params || {};

  const { isInitialLoading, error, data: paymentRequests, refetch } = useQuery({
    queryKey: ['vinte.payment-requests.pending'],
    queryFn: () => api.get(`/vinte/payment-requests?`, { params: { filter_pending: filterPending }}).then(response => response.data),
  })
  
  return (
    <View style={tw``}>
      {
        paymentRequests?.length == 0 &&
        <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin solicitudes registradas</Text>
      }

      <FlatList
        data={paymentRequests}
        contentContainerStyle={tw`pt-2 pb-14`}
        renderItem={({ item }) => <PaymentRequestRow paymentRequest={item} />}
        keyExtractor={(item) => item.uuid}
      />

    </View>
  )
}